"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.folderTree = void 0;
require("./connect");
require("./linkedFolders");
require("./linkFolders");
require("./projects");
require("./detachFolders");
require("./resyncFolders");
const _folderTree = require("../../modules/files/tree/actions");
exports.folderTree = _folderTree.default('vektorio');
//# sourceMappingURL=index.js.map